<app-site-widget
	[title]="title"
	[tooltipText]="tooltipText"
	[elementId]="elementId"
	chartType="progress"
	[widgetClass]="widgetClass"
	[siteWidgetOptions]="siteWidgetOptions"
	[widgetOptions]="{noExpand: true, hasExport:true, hasPrint:true}"
	(eventEmit)="eventEmit($event)"
	[data]="data"
	[hideTable]="true"
	[hideDevs]="true"
	[unitShow]="true"
	[titleStyle]="true"
	[tagStyle]="true"
	[config]="config"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
	[customerName]="customerName"
	[siteName]="siteName"
></app-site-widget>
